<template>
    <div class="matrix-container scroll">
        <div class="matrix">
            <div class="axis axis__y">
                <i class="axis__icon fas fa-arrow-up" />
                <span class="axis__title">
                    {{ yAxisTitle }}
                </span>
            </div>
            <div class="quadrants-container">
                <div class="quadrants">
                    <div
                        :key="`row-${row}`"
                        v-for="row in rows"
                        class="quadrants-row"
                    >
                        <div
                            v-if="isAxisYFirstQuadrant(row)"
                            class="d-flex align-self-left flex-column"
                        >
                            <div class="quadrant_limits limits y_limits">
                                {{ y_limits_values[row] }}
                            </div>
                            <div class="quadrant_limits limits y_limits_0">
                                {{ y_limits_values[0] }}
                            </div>
                        </div>
                        <div v-else class="d-flex align-self-left flex-column">
                            <div class="quadrant_limits limits y_limits">
                                {{ y_limits_values[row] }}
                            </div>
                        </div>
                        <div
                            class="quadrant card"
                            :key="quadrant.id"
                            v-for="(quadrant, index) in matrix[row]"
                        >
                            <slot name="quadrant" :quadrant="quadrant" />
                            <div v-if="isAxisXFirstQuadrant(quadrant)">
                                <div class="quadrant_limits limits x_limits_0">
                                    {{ x_limits_values[0] }}
                                </div>
                                <div class="quadrant_limits limits x_limits">
                                    {{ x_limits_values[index] }}
                                </div>
                            </div>
                            <div v-else>
                                <div class="quadrant_limits limits x_limits">
                                    {{ x_limits_values[index] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="axis axis__x">
                    <span class="axis__title">{{ xAxisTitle }}</span>
                    <i class="axis__icon fas fa-arrow-right" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uniq } from 'lodash'
export default {
    props: {
        matrix: {
            type: Object,
            require: true,
        },
        yAxisTitle: {
            type: String,
            require: true,
        },
        xAxisTitle: {
            type: String,
            require: true,
        },
        quadrants: {
            type: Array,
            require: true,
        },
    },
    computed: {
        rows() {
            return Object.keys(this.matrix).reverse()
        },
        x_limits_values() {
            const arrayLimits_X = []
            for (const quadrant of this.quadrants) {
                this.insertXMinMaxValues(quadrant, arrayLimits_X)
            }
            return uniq(arrayLimits_X)
        },
        y_limits_values() {
            const arrayLimits_y = []
            for (const quadrant of this.quadrants) {
                this.insertYMinMaxValues(quadrant, arrayLimits_y)
            }
            return uniq(arrayLimits_y)
        },
    },
    methods: {
        insertXMinMaxValues(quadrant, arrayLimits_X) {
            if (this.isFirstQuadrant(quadrant)) {
                arrayLimits_X.push(quadrant.x_min)
                arrayLimits_X.push(quadrant.x_max)
            } else {
                arrayLimits_X.push(quadrant.x_max)
            }
        },
        insertYMinMaxValues(quadrant, arrayLimits_y) {
            if (this.isFirstQuadrant(quadrant)) {
                arrayLimits_y.push(quadrant.y_min)
                arrayLimits_y.push(quadrant.y_max)
            } else {
                arrayLimits_y.push(quadrant.y_max)
            }
        },
        isAxisYFirstQuadrant(row) {
            return row == this.rows[this.rows.length - 1]
        },
        isAxisXFirstQuadrant(quadrant) {
            return quadrant == this.matrix[1][1]
        },
        isFirstQuadrant(quadrant) {
            return quadrant == this.quadrants[0]
        },
    },
}
</script>

<style lang="sass" scoped>
$axis-container-height: 25px
$quadrant-box: 280px

.matrix-container
    display: flex

.matrix
    display: flex
    margin: 0 auto

.quadrants-container
    display: flex
    flex-direction: column

.quadrants
    margin-left: 5px
    margin-bottom: 30px

.quadrants-row
    display: flex

.quadrant
    margin: 2px
    height: $quadrant-box
    width: $quadrant-box

.quadrant_limits
    background-color: rgba(0, 155, 219, 0.05)
    border-radius: 0.25rem

.limits
    width: 44px
    height: 23px
    text-align: center
    vertical-align: middle
    color: gray
    font-size: 13px

.x_limits
    float: right

.y_limits
    margin-top: 2px

.x_limits_0
    float: left

.y_limits_0
    margin-top: 234px

.axis
    color: #73818f
    background-color: #edf0f1

.axis__icon
    font-size: 24px

.axis__title
    font-size: 15px
    font-weight: 600

.axis__y
    width: $axis-container-height
    text-align: center
    .axis__title
        text-orientation: inherit
        writing-mode: vertical-lr
        transform: rotate(180deg)
    .axis__icon
        margin-bottom: 10px

.axis__x
    display: flex
    justify-content: flex-end
    width: 100%
    text-align: right
    height: $axis-container-height
    .axis__title
        margin-right: 10px
</style>
